const selectConfig = {
  xlfs: {
    flag1: [{key: '描点', value: '描点'}, {key: '连线', value: '描线'}, {key: '描图', value: '描图'}],
    flag2: [{key: '描点', value: '描点'}, {key: '连线', value: '描线'}, {key: '描图', value: '描图'}],
    flag3: [{key: '描点', value: '描点'}, {key: '连线', value: '描线'}, {key: '描图', value: '描图'}],
    flag4: [{key: '描点', value: '描点'}, {key: '连线', value: '描线'}, {key: '描图', value: '描图'}]
  },
  xljb: {
    flag1: [{key: '初级', value: '初级'}, {key: '中级', value: '中级'}, {key: '高级', value: '高级'}],
    flag2: [{key: '初级', value: '初级'}, {key: '中级', value: '中级'}, {key: '高级', value: '高级'}],
    flag3: [{key: '初级', value: '初级'}, {key: '中级', value: '中级'}, {key: '高级', value: '高级'}],
    flag4: [{key: '初级', value: '初级'}, {key: '中级', value: '中级'}, {key: '高级', value: '高级'}]
  },
  bgType: {
    flag1: [{key: '棋格', value: '棋格'}, {key: '条栅', value: '条栅'}, {key: '方块', value: '方块'}],
    flag2: [{key: '圆点', value: '圆点'}, {key: '线条', value: '线条'}, {key: '方块', value: '方块2'}],
    flag3: [{key: '旋转', value: '旋转'}, {key: '发射', value: '发射'}, {key: '扫描', value: '扫描'}],
    flag4: [{key: '平移', value: '平移'}, {key: '旋转', value: '旋转2'}, {key: '发射', value: '发射2'}]
  },
  bgColor: {
    flag1: {
      '棋格': [{key: '白黑', value: '白黑'}, {key: '红绿', value: '红绿'}, {key: '蓝黄', value: '蓝黄'}],
      '条栅': [{key: '白黑', value: '白黑'}, {key: '红绿', value: '红绿'}, {key: '蓝黄', value: '蓝黄'}],
      '方块': [{key: '白黑', value: '白黑'}]
    },
    flag2: {
      '圆点': [{key: '白黑', value: '白黑'}, {key: '黑白', value: '黑白'}, {key: '红绿', value: '红绿'},
        {key: '绿红', value: '绿红'}, {key: '蓝黄', value: '蓝黄'}, {key: '黄蓝', value: '黄蓝'}],
      '线条': [{key: '白黑', value: '白黑'}, {key: '黑白', value: '黑白'}, {key: '红绿', value: '红绿'},
        {key: '绿红', value: '绿红'}, {key: '蓝黄', value: '蓝黄'}, {key: '黄蓝', value: '黄蓝'}],
      '方块2': [{key: '白黑', value: '白黑'}, {key: '黑白', value: '黑白'}, {key: '红绿', value: '红绿'},
        {key: '绿红', value: '绿红'}, {key: '蓝黄', value: '蓝黄'}, {key: '黄蓝', value: '黄蓝'}],
    },
    flag3: {
      '旋转': [{key: '白黑', value: '白黑'}, {key: '黑白', value: '黑白'}, {key: '红绿', value: '红绿'},
        {key: '绿红', value: '绿红'}, {key: '蓝黄', value: '蓝黄'}, {key: '黄蓝', value: '黄蓝'}],
      '发射': [{key: '红黑', value: '红黑'}, {key: '红白', value: '红白'}],
      '扫描': [{key: '红黑', value: '红黑'}, {key: '红白', value: '红白'}]
    },
    flag4: {
      '平移': [{key: '白黑', value: '白黑'}],
      '旋转2': [{key: '红黑', value: '红黑'}],
      '发射2': [{key: '白黑', value: '白黑'}]
    }
  },
  bgSize: {
    flag1: [{key: '1', value: '9'}, {key: '2', value: '8'}, {key: '3', value: '7'},
      {key: '4', value: '6'}, {key: '5', value: '5'}, {key: '6', value: '4'},
      {key: '7', value: '3'}, {key: '8', value: '2'}, {key: '9', value: '1'}],
    flag2: [{key: '9', value: '1'}],
    flag3: [{key: '9', value: '1'}],
    flag4: [{key: '1', value: '9'}, {key: '2', value: '8'}, {key: '3', value: '7'},
      {key: '4', value: '6'}, {key: '5', value: '5'}, {key: '6', value: '4'},
      {key: '7', value: '3'}, {key: '8', value: '2'}, {key: '9', value: '1'}]
  },
  bgSpeed: {
    flag1: [{key: '慢速', value: '1'}, {key: '中速', value: '3'}, {key: '快速', value: '5'}],
    flag2: [{key: '慢速', value: '1'}, {key: '中速', value: '3'}, {key: '快速', value: '5'}],
    flag3: [{key: '慢速', value: '1'}, {key: '中速', value: '3'}, {key: '快速', value: '5'}],
    flag4: [{key: '慢速', value: '1'}, {key: '中速', value: '3'}, {key: '快速', value: '5'}]
  },
  bh: {
    flag1: [{key: '粗', value: '10'},{key: '中', value: '7'},{key: '细', value: '5'}],
    flag2: [{key: '粗', value: '10'},{key: '中', value: '7'},{key: '细', value: '5'}],
    flag3: [{key: '粗', value: '10'},{key: '中', value: '7'},{key: '细', value: '5'}],
    flag4: [{key: '粗', value: '10'},{key: '中', value: '7'},{key: '细', value: '5'}]
  }
}


export default selectConfig
